module.exports = __webpack_public_path__ + "img/unchecked-box.85f4c44f.svg";